import { v4 as uuidv4 } from 'uuid'
import { identify, isSegmentSendingEvents, track } from '@mc/track-event'
import { trackEmailCapture, EmailCaptureParams } from '../api/emailCapture'

export const trackEmailCaptured = async (payload: {
  event: string
  properties: EmailCaptureParams
  integrations?: Record<string, boolean>
}) => {
  const { properties, event } = payload

  // Generate a unique event ID for deduplication
  const eventId = uuidv4()

  // If cookies are enabled now: sends an identify immediately
  // If cookies are disabled now: queues an identify that will send if cookies are enabled later
  identify(null, {
    email: properties?.email,
    integrations: { Iterable: true },
  })

  // Check if tracking cookies are enabled
  // If the Segment SDK is enabled and sending events, it implies that the user
  // has consented to some combination of the cookie options we provided
  const isSegmentSendingEventsValue = isSegmentSendingEvents()

  // Send only essential data to backend for Iterable tracking
  const essentialEmailCaptureParams: EmailCaptureParams = {
    email: properties?.email,
    event_name: event,
    campaign: properties?.campaign,
    marketing_consent: true,
    product: 'core', // TODO https://masterclass-dev.atlassian.net/browse/PEN-4307
    event_id: eventId,
  }

  // Track essential data on backend via Iterable
  await trackEmailCapture(essentialEmailCaptureParams)

  // Track additional data via Segment from frontend with the same event name and ID
  track(
    event,
    {
      email: properties?.email,
      event_name: event,
      page_source: properties?.page_source,
      campaign: properties?.campaign,
      location: properties?.location,
      content_type: properties?.content_type,
      slug: properties?.slug,
      category: properties?.category,
      cookie_consent: isSegmentSendingEventsValue,
      marketing_consent: true,
      product: 'core', // TODO https://masterclass-dev.atlassian.net/browse/PEN-4307
      event_id: eventId,
    },
    {
      integrations: { All: false, Iterable: true },
      messageId: eventId, // messageId will deduplicate the event in Iterable
    },
  )
}
